import { axiosClient } from '@/api/axiosClient';
import { FileUploadModel, INetworkResponse } from '@/models';

const uploadAPI = {
  upload(
    formData: FormData,
    onUpload?: (progressEvent: ProgressEvent) => void,
    onDownload?: (progressEvent: ProgressEvent) => void,
    typeUpload?: 'avatar' | 'file' | 'image'
  ): Promise<INetworkResponse<FileUploadModel>> {
    // Upload base differs from the CMS API base: the CMS sits under /cms,
    // uploads are under /upload. Derive from VITE_UPLOAD_API_URL when set
    // (compose passes this to the dev container); otherwise fall back to the
    // origin of VITE_BASE_API_URL so the staging/production builds keep
    // pointing at the deployed gateway.
    const baseFromEnv = (import.meta.env.VITE_UPLOAD_API_URL as string | undefined)?.trim();
    let baseUpload = baseFromEnv;
    if (!baseUpload) {
      const apiBase = (import.meta.env.VITE_BASE_API_URL as string | undefined) ?? '';
      // Strip trailing /cms (or /cms/...) so /upload sits at the same origin.
      baseUpload = apiBase.replace(/\/cms\/?$/, '');
    }
    let url = '';
    if (typeUpload === 'avatar' || typeUpload === 'image') {
      url = `${baseUpload}/upload/image`;
    } else if (typeUpload === 'file') {
      url = `${baseUpload}/upload/file`;
    }
    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
      onDownloadProgress: onDownload,
      onUploadProgress: onUpload,
    };

    return axiosClient.post(url, formData, config);
  },
};

export { uploadAPI };
